// extracted by css-extract-rspack-plugin
export default {"Text":"AuthorDisplayName-module__Text__wpf1GkQ","truncate":"AuthorDisplayName-module__truncate__B2zTJZ_"};